import React, {FC, useState} from "react";
import {ConfigAddressApi, OrderType, PlaceApi, StoreConfigCoordinatesApi} from "../../../services/Api/types";
import {useNavigate} from "react-router-dom";
import ChangeLocationMultistoreModal from "./ChangeLocationMultistoreModal";
import {RootState} from "../../../../reducers";
import {getSession} from "../../../services/Session/reducer";
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {ReactComponent as AlertErrorSVG} from "../../../../images/icons/alert-error.svg";
import {api} from "../../../services/Api/api";
import LoadingContainer from "../../../components/Common/LoadingContainer";
import IframeWidget from "../../../utils/IframeWidget";
import PopupModal from "../../../components/Modal/PopupModal";

interface OwnProps {
    onHide: () => void;
    place?: PlaceApi | undefined,
    openStore: (place: PlaceApi) => void,
    storeUrl: string;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

const getDefaultView = (orderTypes: OrderType[], coordinates: StoreConfigCoordinatesApi | undefined) => {
    if (orderTypes.length === 1) {
        const type = orderTypes[0];

        if (type === OrderType.DELIVERY) {
            if (!coordinates) {
                return "LOCATION_REQUIRED";
            }
            return "NOT_DELIVERY_ZONE";
        }

        return "ORDER_TYPE";
    } else {
        return "ORDER_TYPE";
    }
}

const RequiredLocationModalComponnent: FC<Props> = (props) => {
    const types = props.place?.types || [];
    const [orderType, setOrderType] = useState<string | undefined>(undefined);
    const [show, setShow] = useState(true);
    const [loading, setLoading] = useState(false);
    const [view, setView] = useState(getDefaultView(types, props.session.coordinates));
    const navigate = useNavigate();
    const {t} = useTranslation();

    const updateOrderType = (value: string) => {
        setOrderType(value);
        if (value == "PICK_UP") {
            IframeWidget.onHide(props.onHide);
            navigate(`${props.storeUrl}/PICK_UP`);
            return;
        }
        if (value == "DINE_IN") {
            IframeWidget.onHide(props.onHide);
            navigate(`${props.storeUrl}/DINE_IN`);
            return;
        }
        if (value == "DELIVERY") {
            if (props.place?.in_delivery_zone) {
                IframeWidget.onHide(props.onHide);
                navigate(`${props.storeUrl}/DELIVERY`);
                return;
            }
            if (!props.session.coordinates) {
                setView("LOCATION_REQUIRED")
            } else {
                setView("NOT_DELIVERY_ZONE")
            }
        }
    }
    const renderChooseType = () => {
        if (types?.length === 1) return <></>;

        return (
            <>
                {(types && types.length > 0) ? (
                    <>

                        {types.includes(OrderType.DELIVERY) && (
                            <button type="button"
                                    className={`btn w-100 mb-2 btn-outline-primary`}
                                    onClick={() => updateOrderType("DELIVERY")}>
                                {t("enums.order.type.DELIVERY")}
                            </button>
                        )}
                        {types.includes(OrderType.PICK_UP) && (
                            <button type="button"
                                    className={`btn w-100 mb-2 btn-outline-primary`}
                                    onClick={() => updateOrderType("PICK_UP")}>
                                {t("enums.order.type.PICK_UP")}
                            </button>
                        )}

                        {types.includes(OrderType.DINE_IN) && (
                            <button type="button"
                                    className={`btn w-100 mb-2 btn-outline-primary`}
                                    onClick={() => updateOrderType("DINE_IN")}>
                                {t("enums.order.type.DINE_IN")}
                            </button>
                        )}
                    </>
                ) : (
                    <div className={"alert alert-danger"}>
                        {t("constraints.internal.place_with_not_types")}
                    </div>
                )}

            </>
        )
    }
    const onChangeLocation = async (address: ConfigAddressApi, coordinates: StoreConfigCoordinatesApi) => {
        setLoading(true);
        const places = await api.getPlaces(coordinates)
        const currentPlace = places.filter(x => x.domain === props.place?.domain)[0];
        if (!currentPlace || !currentPlace.in_delivery_zone) {
            setView("NOT_DELIVERY_ZONE")
            setLoading(false);
            return;
        }
        IframeWidget.onHide(props.onHide)
        navigate(props.storeUrl);
    }

    if (view === "LOCATION_REQUIRED") {
        return <ChangeLocationMultistoreModal showModal={true} onHide={props.onHide} onChange={onChangeLocation}/>
    }

    const getModalContent = () => {
        if (loading) {
            return (
                <div className={"modal-info"}>
                    <LoadingContainer>
                        {t("modules.multistore.field.check_address_pending.title")}
                    </LoadingContainer>
                </div>
            )
        }

        return (
            <div className={"modal-info"}>
                {renderChooseType()}
            </div>
        )
    }

    const getModalHeaderIcon = () => {
        if (view === "NOT_DELIVERY_ZONE") return <AlertErrorSVG/>
    }

    const getModalHeaderIconClassName = () => {
        if (view === "NOT_DELIVERY_ZONE") return "text-danger";
    }

    const getModalPrimaryButton = () => {
        if (view === "NOT_DELIVERY_ZONE") return <button className={"btn btn-default w-100"}
                                                         onClick={() => setView("LOCATION_REQUIRED")}>
            {t("modules.multistore.action.change_address.title")}
        </button>
    }

    const getModalSecondaryButton = () => {
        if (view === "NOT_DELIVERY_ZONE") return <button className={"btn btn-default w-100"}
                                                         onClick={() => IframeWidget.onHide(props.onHide)}>
            {t("modules.multistore.action.change_restaurant.title")}
        </button>
    }

    const getModalTitle = () => {
        if (view === "NOT_DELIVERY_ZONE") return t("modules.multistore.field.delivery_not_available.title");
        return t("modules.multistore.field.choose_order_type.title");
    }

    const getModalDescription = () => {
        if (view === "NOT_DELIVERY_ZONE") return t("modules.multistore.field.delivery_not_available.description");
    }


    return <PopupModal
        bodyContent={getModalContent()}
        title={getModalTitle()}
        description={getModalDescription()}
        show={show}
        onHide={props.onHide}
        headerIcon={getModalHeaderIcon()}
        headerIconClassName={getModalHeaderIconClassName()}
        primaryButton={getModalPrimaryButton()}
        secondaryButton={getModalSecondaryButton()}
    />
};


const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(RequiredLocationModalComponnent));
